export default {
  id: "grand-openings",
  name: "Grand Openings",
  shortName: "Openings",
  description: "NRO timelines & Asana sync",
  icon: "calendar",
  color: "#34D399",
  roles: ["super_admin", "admin", "corporate"],
  css: "styles/apps/grand-openings.css",
  nav: [
    { id: "timeline", label: "Timeline" },
  ],
  defaultView: "timeline",
};
